import { CorreoSalidaEntity } from '../models/alertas.model';

export interface ResultadoEnvio {
  ok: boolean;
  error?: string;
  idProveedor?: string;
}

/**
 * Puerto de envío de correo. MVP: bandeja simulada (no sale nada a internet).
 * Integración: el backend despacha el outbox con node-cron + `MailSend` (AWS SES).
 */
export abstract class CorreoPort {
  abstract enviar(correo: CorreoSalidaEntity): Promise<ResultadoEnvio>;
  abstract simularFallos(activo: boolean): void;
  abstract fallosSimulados(): boolean;
}
